import React from 'react';
import Col from 'react-bootstrap/Col';

function StepsCard(props) {
  return (
    <Col lg={4} md={6}>

      <div className="steps-image">
        <img
          src={props.image}
          width="100%"
          alt="step1-image"
        />
      </div>

      <p className="sub-heading" style={{ marginBottom: '0' }}>
        Step
        {' '}
        {props.stepNumber}
      </p>
      <h3 style={{ marginBottom: '15px', fontWeight: '500' }}>{props.title}</h3>
      <p>
        {props.content}
      </p>
      {props.subContent}
    </Col>
  );
}

export default StepsCard;
